import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  styled,
  Link,
  Grid,
} from "@mui/material";
import AppHeader from "../components/AppHeader";
import { BLOG_POSTS } from "../posts";

const BlogContainer = styled(Container)(({ theme }) => ({
  padding: "2rem",
  margin: "0 auto",
  maxWidth: "1200px",
}));

const PostCard = styled(Link)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  textDecoration: "none",
  color: "inherit",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  overflow: "hidden",
  transition: "box-shadow 0.3s ease",
  "&:hover": {
    boxShadow: theme.shadows[4],
  },
}));

const Thumbnail = styled("img")({
  width: "100%",
  height: "250px",
  objectFit: "contain",
});

const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
}));

const BlogIndexPage = () => {
  const sortedPosts = [...BLOG_POSTS]
    .filter((post) => post.category !== "hiring")
    .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));

  return (
    <Box>
      <AppHeader />
      <BlogContainer>
        <Typography variant="h1" sx={{ mb: 4 }}>
          Blog
        </Typography>
        <Grid container spacing={4}>
          {sortedPosts.map((post) => (
            <Grid item xs={12} sm={6} md={4} key={post.slug}>
              <PostCard component={RouterLink} to={post.slug}>
                <Thumbnail src={post.thumbnail} alt={post.title} />
                <CardContent>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h5" component="h2" gutterBottom>
                      {post.title}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {post.publishDate}
                  </Typography>
                </CardContent>
              </PostCard>
            </Grid>
          ))}
        </Grid>
      </BlogContainer>
    </Box>
  );
};

export default BlogIndexPage;
